import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { StyledLink } from "orcs-design-system";
import { useOrgBranding } from "src/hooks/orgConfig";

/* Styled Components */
const AppHomeLink = styled(StyledLink)`
  display: none !important;

  &:hover {
    text-decoration: none;
  }

  @media screen and (min-width: ${(props) =>
    themeGet("breakpoints.2")(props)}) {
    display: inline-block !important;
  }
`;

const AppName = ({ defaultRoutePath }) => {
  const { branding } = useOrgBranding();

  const appName = branding?.appName;

  return <AppHomeLink to={defaultRoutePath}>{appName}</AppHomeLink>;
};

AppName.propTypes = {
  defaultRoutePath: PropTypes.string,
};

export default AppName;
